var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddBoardBtn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 37.6803C29.665 37.6803 37.5 29.8453 37.5 20.1803C37.5 10.5153 29.665 2.6803 20 2.6803C10.335 2.6803 2.5 10.5153 2.5 20.1803C2.5 29.8453 10.335 37.6803 20 37.6803ZM20 40.1803C31.0457 40.1803 40 31.226 40 20.1803C40 9.1346 31.0457 0.180298 20 0.180298C8.9543 0.180298 0 9.1346 0 20.1803C0 31.226 8.9543 40.1803 20 40.1803Z",
    fill: "#3A3845"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 11.4303C20.6903 11.4303 21.25 11.9899 21.25 12.6803V18.9303H27.5C28.1903 18.9303 28.75 19.49 28.75 20.1803C28.75 20.8705 28.1903 21.4303 27.5 21.4303H21.25V27.6803C21.25 28.3705 20.6903 28.9303 20 28.9303C19.3097 28.9303 18.75 28.3705 18.75 27.6803V21.4303H12.5C11.8097 21.4303 11.25 20.8705 11.25 20.1803C11.25 19.49 11.8097 18.9303 12.5 18.9303H18.75V12.6803C18.75 11.9899 19.3097 11.4303 20 11.4303Z",
    fill: "#3A3845"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddBoardBtn);
export default __webpack_public_path__ + "static/media/addBoardBtn.ff0e8cbb5399b29c0654c8b89a86f2fe.svg";
export { ForwardRef as ReactComponent };